import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { OrderConfirmationRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { OrderConfirmationResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const confirmOrder = (request: OrderConfirmationRequest, options?: CashRequestOptions) =>
  post<OrderConfirmationRequest, OrderConfirmationResponse>('/2.0/cash/confirm-order', request, {
    ...options,
    rejectOnError: true,
  })
